import DOMPurify from 'dompurify';
import { DomSanitizer } from '@angular/platform-browser';
import { Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';

@Pipe({
    name: 'ghSafeHtml',
    standalone: false
})
export class GhSafeHtmlPipe implements PipeTransform {

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    protected sanitizer: DomSanitizer
  ) { }

  transform(value: any, type = { ADD_TAGS: ['iframe'], ADD_ATTR: ['target'] }): any {
    // BROWSER
    if (!isPlatformBrowser(this.platformId)) {
      return value;
    }
    const sanitizedContent = DOMPurify.sanitize(value, type);
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);

  }
}
